import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { VrstaKomitenta } from './vrsta-komitenta';
import { ActivatedRoute } from '@angular/router';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-vrsta-komitenta-update',
  templateUrl: './vrsta-komitenta-update.component.html'
})
export class VrstaKomitentaUpdateComponent extends BaseUpdateComponent<VrstaKomitenta> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'VRSTAKOMITENTA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(10), 'maxlength', 'VRSTAKOMITENTA.NAZIV.VALIDATION.MAXLENGTH');
  }

}
